import React, { FC } from "react";
import pageStyles from "../page.css";
import { UserSettingsContainer } from "../../containers/configuration/user-settings/user-settings-container";

const { ["page-content"]: pageContentClassName } = pageStyles as any;

export const UserSettingsPage: FC = () => {
  return (
    <div className={pageContentClassName}>
      <div>
        <UserSettingsContainer />
      </div>
    </div>
  );
};
